<div
  class="wrapper"
  [ngClass]="{ 'manage-profile': manageProfile, filters: filters }"
>
  <div class="input-wrapper">
    <app-shared-input
      for="cbsaSearch"
      [value]="searchTerm"
      [touched]="true"
      [borderError]="borderError"
      [disabled]="disabled"
    >
      <input
        #cbsaSearchInput
        id="cbsaSearch"
        name="cbsaSearch"
        [(ngModel)]="searchTerm"
        (input)="onSearchChange()"
        (focus)="handleFocus($event)"
        [disabled]="disabled"
        [autofocus]="autofocus"
      />
    </app-shared-input>
  </div>

  <section *ngIf="!!loading" class="status-info">
    Finding matching ZIP codes, counties and CBSAs...
  </section>

  <ng-container *ngIf="!loading">
    <section *ngIf="searchTerm.length < 3" class="status-info">
      Enter at least 3 characters to search.
    </section>

    <section
      *ngIf="searchTerm.length >= 3 && !options.length"
      class="status-info"
    >
      We <span class="font-semibold">could not find any matching</span> ZIP
      codes, counties or CBSAs. Try searching for a different term.
    </section>

    <section *ngIf="options.length" class="options">
      <div
        *ngFor="let option of options; trackBy: trackByOptionKey"
        class="item"
        [ngClass]="{ selected: option.selected }"
        (click)="toggleSelected(option)"
      >
        <ng-icon
          [name]="option.selected ? 'featherCheckSquare' : 'featherSquare'"
        ></ng-icon>
        <div class="info">
          <div class="label" [innerHTML]="option.formattedPreference"></div>
          <div
            *ngIf="option.formattedType"
            class="desc"
            [innerHTML]="option.formattedType"
          ></div>
        </div>
      </div>
    </section>
  </ng-container>

  <section *ngIf="selected && selected.length" class="selected">
    <div class="title">
      Your current market selection ({{ selected.length }}):
    </div>
    <div class="items-container">
      <div
        class="items"
        [ngClass]="{ collapsed: !showMoreItems && needsCollapse }"
      >
        <div
          *ngFor="let item of selected; trackBy: trackBySelectedKey"
          class="item"
        >
          <div class="label">
            {{ item.formattedPreference }} <sup>({{ item.formattedType }})</sup>
          </div>
          <div
            class="remove"
            (click)="removeSelected(item)"
            [ngClass]="{ disabled: disabled }"
          >
            <ng-icon name="featherXCircle" size="13"></ng-icon>
          </div>
        </div>
      </div>

      <div
        *ngIf="needsCollapse"
        class="show-more"
        [ngClass]="{
          'remove-gradient': showMoreItems,
          'manage-profile': manageProfile
        }"
        (click)="toggleShowMoreItems()"
      >
        {{ showMoreItems ? 'Show less' : 'Show more' }}
      </div>
    </div>
  </section>

  <div *ngIf="selected.length === 0 && !filters" class="input-error-message">
    Please select at least one market to proceed.
  </div>
</div>
